import ContactsService from "../services/contactsService";
import ActionTypes from "./actionTypes";

/**
 * Loads the Business Directory™ from the server.
 *
 * @param {String}  securityToken   The security token for the user.
 */
export function loadBusinessDirectory(securityToken) {
  return (dispatch, getstate) => {
    if (!securityToken) {
      securityToken = getstate().user.securityToken;
    }

    dispatch({
      type: ActionTypes.BUSINESS_DIRECTORY_LOADING,
      payload: {},
    });

    ContactsService.getBusinessDirectory(
      getstate().config.server,
      securityToken,
      dispatch,
      getstate().network.serverError
    )
      .then(data => {
        dispatch({
          type: ActionTypes.BUSINESS_DIRECTORY_LOADED,
          payload: data,
        });
      })
      .catch(error => {});
  };
}



// WEBPACK FOOTER //
// ./src/actions/businessDirectoryActions.js